export default "__VITE_ASSET__C0A95M54__"